/**
 * Created by hp on 2017/6/26.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'react-weui';
import axios from 'axios';

class ChannelFreeChannel extends Component {
    constructor() {
        super();
        this.handleSubscribeChannel = this.handleSubscribeChannel.bind(this);

        this.state = {
            initialized: false,
            qrcode: '',
        }
    }

    handleSubscribeChannel() {
        const {channel, account} = this.props;
        const {initialized, qrcode} = this.state;

        if (account.subscribed) {
            this.props.dispatch({
                type: 'SUBSCRIBE_CHANNEL_SHOW',
                payload: {
                    id: channel.id,
                    name: channel.name,
                    cover: channel.cover_url,
                }
            })
        } else {
            if (!initialized) {
                this.props.dispatch({
                    type: 'SUBSCRIBE_CHANNEL_SHOW',
                    payload: {
                        id: channel.id,
                        name: channel.name,
                        cover: channel.cover_url,
                        qrcode: ''
                    }
                });
                this.setState({initialized: true});
            } else {
                this.props.dispatch({
                    type: 'SUBSCRIBE_CHANNEL_SHOW',
                    payload: {
                        id: channel.id,
                        name: channel.name,
                        cover: channel.cover_url,
                        qrcode: qrcode,
                    }
                });
            }
        }
    }

    render() {
        return (
            <div className="channel-pay-channel" style={{width:'100%'}}>
                <Button className="weui-flex__item flex_3" onClick={this.handleSubscribeChannel}>预约专栏</Button>
            </div>
        )
    }
}

ChannelFreeChannel.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    account: state.account,
    channel: state.channel.channel
}))(ChannelFreeChannel)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelFreeChannel.js